module.exports = new __parcel__URL__("shop_star_wolvez_hoodie_image.df1816aa.png").toString();